<template>
  <b-modal
    id="employee-modal"
    size="lg"
    :title="isEdit ? $t('generals.edit') : $t('generals.add')"
    ok-variant="success"
    :ok-title="isEdit ? $t('generals.update') : $t('generals.add')"
    cancel-variant="danger"
    :cancel-title="$t('generals.cancel')"
    no-close-on-backdrop
    @ok="onSubmit"
    @hidden="onHidden"
    @show="onShow(employee)"
  >
    <validation-observer ref="infoEmployee">
      <b-row>
        <b-col md="12">
          <b-form-group
            :label="$t('clients.bayers_full_name') + ':'"
            label-for="name"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('clients.bayers_full_name')"
              rules="required"
            >
              <b-form-input
                id="name"
                v-model="agent.name"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- <b-col
          md="12"
        >
          <label
            class="mt-50"
            for=""
          >{{ $t('clients.buyers_phone_number') }}</label>
          <b-form-tags
            v-model="agent.phones"
            :placeholder="$t('generals.add')"
            input-id="tags-basic"
            class="mb-2"
            :add-button-text="$t('clients.new')"
          />
        </b-col> -->
        <b-col md="12">
          <b-form-group :label="$t('clients.buyers_phone_number')">
            <div
              v-for="(phone, index) in agent.phones"
              :key="index"
              class="d-flex mt-1"
            >
              <b-form-input v-model="agent.phones[index]" />
              <b-button
                class="ml-1"
                variant="danger"
                @click="removePhoneNumber(index)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
            <b-button class="mt-1" @click="addNewPhoneNumber">
              <feather-icon icon="PlusIcon" />
              {{ $t("clients.add_new_phone_number") }}
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <app-collapse>
        <app-collapse-item
          :is-visible="true"
          :title="$t('clients.passport_details')"
        >
          <b-row>
            <b-col md="12">
              <b-row>
                <b-col md="12">
                  <b-form-group :label="$t('clients.passport_type') + ':'">
                    <div class="d-flex align-items-center mt-50">
                      <b-form-radio
                        v-model="passport_is_new"
                        class="mb-2"
                        name="some-radios"
                        :value="false"
                      >
                        {{ $t("clients.old") }}
                      </b-form-radio>

                      <b-form-radio
                        v-model="passport_is_new"
                        class="mb-2 ml-4"
                        name="some-radios"
                        :value="true"
                      >
                        {{ $t("clients.new") }}
                      </b-form-radio>
                    </div>
                  </b-form-group>
                </b-col>

                <b-col v-if="!passport_is_new" md="12">
                  <b-row>
                    <b-col md="4">
                      <b-form-group
                        :label="$t('clients.series') + '*'"
                        label-for="seria"
                      >
                        <validation-provider
                          #default="{ errors }"
                          rules="required|length:2"
                          :name="$t('clients.series')"
                        >
                          <b-form-input
                            id="seria"
                            v-model="agent.passport.seria"
                            placeholder="AB"
                            class="passport__style"
                            type="text"
                            :trim="true"
                          />

                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="8">
                      <b-form-group
                        :label="$t('clients.passport_number') + '*'"
                        label-for="number-passport"
                        style="width: 100%"
                      >
                        <validation-provider
                          #default="{ errors }"
                          rules="required|length:7"
                          :name="$t('clients.passport_number')"
                        >
                          <b-form-input
                            id="number-passport"
                            v-model="agent.passport.number"
                            class="w-100"
                            placeholder="1234567"
                            type="number"
                            :trim="true"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col v-else md="12">
                  <b-form-group label="ID*" label-for="Id">
                    <validation-provider
                      #default="{ errors }"
                      rules="required|length:7"
                      :name="$t('clients.passport_id')"
                    >
                      <b-form-input
                        id="basicInput"
                        v-model="agent.passport.id"
                        placeholder="ID"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-row>
                    <b-col md="6">
                      <b-form-group
                        :label="$t('clients.date_of_issue') + '*'"
                        label-for="passport_given_date"
                      >
                        <validation-provider
                          #default="{ errors }"
                          rules="required"
                          :name="$t('clients.date_of_issue')"
                        >
                          <date-picker
                            v-model="agent.passport.passport_given_date"
                            mode="date"
                            :model-config="{
                              type: 'string',
                              mask: 'YYYY-MM-DD',
                            }"
                            locale="ru"
                          >
                            <template v-slot="{ inputValue, togglePopover }">
                              <input
                                class="bg-white form-control border px-2 py-1 rounded"
                                :value="inputValue"
                                @click="togglePopover()"
                              />
                            </template>
                          </date-picker>
                          <!-- <flat-pickr
                            v-model="agent.passport.passport_given_date"
                            class="form-control"
                          /> -->
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="6">
                      <b-form-group
                        :label="$t('clients.validity_period') + '*'"
                        label-for="passport_expire_date"
                      >
                        <validation-provider
                          #default="{ errors }"
                          rules="required"
                          :name="$t('clients.validity_period')"
                        >
                          <!--   v-model="agent.passport.passport_expire_date" -->
                          <date-picker
                            v-model="agent.passport.passport_expire_date"
                            :model-config="{
                              type: 'string',
                              mask: 'YYYY-MM-DD',
                            }"
                            locale="ru"
                          >
                            <template v-slot="{ inputValue, togglePopover }">
                              <input
                                class="bg-white form-control border px-2 py-1 rounded"
                                :value="inputValue"
                                @click="togglePopover()"
                              />
                            </template>
                          </date-picker>
                          <!-- <flat-pickr
                            v-model="agent.passport.passport_expire_date"
                            class="form-control"
                          /> -->
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    :label="$t('clients.issued_by_whom') + '*'"
                    label-for="issued-by"
                    style="width: 100%"
                  >
                    <validation-provider
                      #default="{ errors }"
                      rules="required"
                      :name="$t('clients.issued_by_whom')"
                    >
                      <b-form-textarea
                        id="issued-by"
                        v-model="agent.passport.passport_given_by"
                        class="w-100"
                        :placeholder="$t('clients.issued_by_whom')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="12">
              <validation-provider
                #default="{ errors }"
                rules="length:14"
                :name="$t('clients.pinfl')"
              >
                <b-form-group :label="$t('clients.pinfl') + ':'">
                  <b-form-input v-model="agent.pin" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <b-form-group :label="$t('references.address') + ':'">
                <b-form-input v-model="agent.passport.address" />
              </b-form-group>
            </b-col>
          </b-row>
        </app-collapse-item>
        <app-collapse-item :title="$t('clients.additional_info')">
          <b-row>
            <b-col md="4">
              <b-form-group :label="$t('clients.additional_info') + ':'">
                <b-form-input v-model="agent.info.telegram" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="E-mail:">
                <b-form-input v-model="agent.info.email" />
              </b-form-group>
            </b-col>
          </b-row>
        </app-collapse-item>
      </app-collapse>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  // BFormTags,
  BFormTextarea,
  BFormRadio,
  BButton,
} from "bootstrap-vue";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { required, length } from "@validations";
import { mapActions } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    BModal,
    BRow,
    BFormInput,
    BFormGroup,
    // BFormTags,
    BFormTextarea,
    BCol,
    ValidationProvider,
    ValidationObserver,
    BFormRadio,
    AppCollapse,
    AppCollapseItem,
    DatePicker,
    BButton,
  },
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    employee: {
      type: null,
      required: false,
      default: () =>  ({
        name: "",
        phones: [""],
        info: {},
        passport: {},
      }),
    },
    parent_id: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isPassport: false,
      required,
      length,
      phones: [],
      passport_is_new: false,
      passport: {
        new: {
          id: null,
        },
        old: {
          seria: null,
          number: null,
        },
      },
      agent: {
        name: "",
        phones: [""],
        info: {},
        passport: {
          passport_given_date: null,
          passport_expire_date: null,
          passport_given_by: "",
        },
      },
    };
  },
  // watch: {
  // },
  methods: {
    ...mapActions("clients", ["ADD_NEW_EMPLOYEE", "UPDATE_ONE_EMPLOYEE"]),
    onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.$refs.infoEmployee.validate().then(async (success) => {
        if (success) {
          this.agent.phones = this.agent.phones.map((el) =>
            el.replaceAll(/[^0-9]/g, "")
          );
          if (this.passport_is_new) {
            this.$delete(this.agent.passport, "seria");
            this.$delete(this.agent.passport, "number");
          } else {
            this.$delete(this.agent.passport, "id");
          }
          if (this.isEdit) {
            console.log(this.agent);
            this.UPDATE_ONE_EMPLOYEE(this.agent).then(() => {
              this.$bvModal.hide("employee-modal");
              this.$_successToast(this.$t("generals.updated"));
              this.$emit("success");
            });
          } else {
            this.agent.company = this.parent_id;
            this.ADD_NEW_EMPLOYEE(this.agent).then(() => {
              this.$bvModal.hide("employee-modal");
              this.$_successToast(this.$t("generals.added"));
              this.$emit("success");
            });
          }
        }
        // if (success) {
        //   this.phones.forEach(phone => {
        //     this.agent.phones.push(phone)
        //   })

        //   if (this.isPassport) {
        //     if (this.passport_is_new) {
        //       this.agent.passport = {
        //         ...this.agent.passport,
        //         ...this.passport.new,
        //       }
        //     } else {
        //       this.agent.passport = {
        //         ...this.agent.passport,
        //         ...this.passport.old,
        //       }
        //     }
        //   } else {
        //     delete this.agent.passport
        //   }

        //   this.agent.company = this.parent_id

        //   if (!this.employee) {
        //     await this.ADD_NEW_EMPLOYEE(this.agent)
        //   } else {
        //     await this.UPDATE_ONE_EMPLOYEE({
        //       id: this.employee.id,
        //       data: this.agent,
        //     })
        //   }

        //   this.$nextTick(() => {
        //     this.$bvModal.hide('employee-modal')
        //   })

        //   this.$emit('refresh')

        //   this.claarData()
        // }
      });
    },
    addNewPhoneNumber() {
      this.agent.phones.push("");
    },
    removePhoneNumber(index) {
      this.agent.phones.splice(index, 1);
    },
    onShow(newValue) {
      this.agent = newValue;
      if (Object.prototype.hasOwnProperty.call(newValue.passport, "id")) {
        this.passport_is_new = true;
      } else if (
        Object.prototype.hasOwnProperty.call(newValue.passport, "seria")
      ) {
        this.passport_is_new = false;
      }
      // if (!newValue) {
      //   this.claarData()
      // }

      // const {
      //   passport, is_chief, name, phones,
      // } = newValue

      // if (passport.id) {
      //   this.passport_is_new = true
      //   this.passport.new.id = passport.id
      // } else {
      //   this.passport_is_new = false
      //   this.passport.old = {
      //     seria: passport.seria,
      //     number: passport.number,
      //   }
      // }

      // this.agent.passport.passport_given_date = passport.passport_given_date
      // this.agent.passport.passport_expire_date = passport.passport_expire_date
      // this.agent.passport.passport_given_by = passport.passport_given_by

      // this.agent.passport = {
      //   passport_given_date: passport.passport_given_date,
      //   passport_expire_date: passport.passport_expire_date,
      //   passport_given_by: passport.passport_given_by,
      // }

      // this.agent.is_chief = is_chief
      // this.agent.name = name
      // this.phones = Object.keys(phones).map(key => phones[key])
    },
    onHidden() {
      this.agent = {
        name: "",
        phones: [""],
        info: {},
        passport: {
          passport_given_date: null,
          passport_expire_date: null,
          passport_given_by: "",
        },
      };
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
